import React, { useState, useEffect, useRef, useContext } from 'react'
import Card from '../../../Base/Components/Card/Card';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import { Button, Calendar } from 'primereact';
import { getDateProduction } from '../../../Base/Services/FechasService';
import { getIngresosBodegaMantenimientoFecha, getIngresosDetallesFechas } from '../../../API/Mantenimiento/Ingresos/IngresosRequests';
import { Tag } from 'primereact/tag';
import CalendarioOperativo from '../../../Base/Components/CalendarioOperativo/CalendarioOperativo';
import { getInformacionEncabezadoCXP } from '../../../Base/API/CuentasPorPagar/CXP/CuentasPorPagarRequest';
import ModalCuentasPorPagarCompras from '../../../Base/Screens/Proveedores/CuentasPorPagar/ModalCXP/ModalCuentasPorPagarCompras';
import Loader from '../../../Base/Components/Loader/Loader';
import { Toast } from 'primereact/toast';
import { toastShow } from '../../../Base/Services/ToastService';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';

const IngresosMantenimiento = () => {
    const toast = useRef(null)
    const [ingresos, setIngresos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dates, setDates] = useState([new Date(), new Date()]);
    const [data, setData] = useState([]);
    const [dialogFactura, setDialogFactura] = useState(false);
    const [IdFactura, setIdFactura] = useState(null);

    const { userAuth } = useContext(AuthContext)

    const obtenerIngresosFechas = async () => {
        setLoading(true)
        setData([])

        if (!dates[0] !== null) {
            if (!dates[1]) {
                toastShow(toast, 'warn', 'Error', 'Seleccione dos fechas para buscar');
            }
            else {
                const fechaFormato = getDateProduction(dates)
                const result = await getIngresosDetallesFechas(fechaFormato)
                setData(result)


            }

        } else {
            toastShow(toast, 'error', 'Error', 'Debe de selecionar una fecha.');
        }

        setLoading(false)

    }

    const EstadoTemplate = (rowData) => {
        switch (rowData.IdEstadoFinanzas) {
            case 3581:
                return <Tag style={{ width: 100, backgroundColor: "rgb(0, 191, 57)" }} value={rowData.StatusFinanzas} />
                break;
            case 3580:
                return <Tag style={{ width: 100, backgroundColor: "rgb(227, 63, 63)" }} value={rowData.StatusFinanzas} />
                break;
            case 3607:
                return <Tag style={{ width: 100, backgroundColor: "rgb(217, 206, 41)" }} value={rowData.StatusFinanzas} />
                break;
            case 3713:
                return <Tag style={{ width: 100, backgroundColor: "rgb(63, 142, 227)" }} value={rowData.StatusFinanzas} />
                break;
             case 3714:
                            return <Tag style={{ width: 100, backgroundColor: "rgba(0, 191, 57, 0.75)" }} value={rowData.EstadoFinanzas} />
                            break;

            default:
                return <div><span>{rowData.StatusFinanzas}</span></div>
                break;
        }
    }



    // const columns = [
    //     {
    //         header: 'Ingreso',
    //         field: 'NumeroIngreso',
    //         frozen: 'true',
    //         className: 'small'
    //     },
    //     {
    //         header: 'Fecha',
    //         field: 'Fecha',
    //         Formtat: 'DateTime'
    //     },
    //     {
    //         header: 'Producto',
    //         field: 'NombreProducto',
    //         className: 'small',
    //         minWidth: 300,
    //         flex: 1
    //     },
    //     {
    //         header: 'Tipo',
    //         field: 'TipoIngreso',
    //     },
    //     {
    //         field: 'EstadoFinanzas',
    //         header: 'Estado Finanzas',
    //         headerEn: 'Finance Status',
    //         className: 'small',
    //         Format: 'Template',
    //         body: (rowData) => EstadoTemplate(rowData),
    //     },

    //     {
    //         header: 'Categoria',
    //         field: 'NombreCategoria',
    //     },
    //     {
    //         header: 'SubCategoria',
    //         field: 'NombreSubCategoria',
    //     },
    //     {
    //         header: 'Purchase Order',
    //         field: 'PurchaseOrder',
    //         className: 'small'
    //     },
    //     {
    //         header: 'Cantidad',
    //         field: 'Ingreso',
    //         Format: 'Decimal',
    //         Sumary: 'sum',
    //         className: 'small',
    //         frozen: 'true',
    //         alignFrozen: 'right',
    //     },
    //     {
    //         header: 'Unidad',
    //         field: 'UnitName',
    //         className: 'small',
    //         frozen: 'true',
    //         alignFrozen: 'right',
    //     },


    // ];


    // const table = {
    //     Data: ingresos,
    //     Columns: columns,
    //     loading: loading
    // }

    const OpenDocumento = async (rowData) => {
        let tipoReferencia
        switch (true) {
            case [3, 7].includes(rowData?.IdTipoIngreso):
                tipoReferencia = 1
                break;
            case [4].includes(rowData?.IdTipoIngreso):
                tipoReferencia = 3
                break;
            case [5].includes(rowData?.IdTipoIngreso):
                tipoReferencia = 2
                break;
            case [6].includes(rowData?.IdTipoIngreso):
                tipoReferencia = 6
                break;

            default:
                tipoReferencia = 3
                break;
        }
        let informacionEnviar = {
            IdIngreso: rowData?.IdIngreso,
            IdReferencia: tipoReferencia,
            NumeroIngreso: rowData?.NumeroIngreso
        }

        const tempoCXP = await getInformacionEncabezadoCXP(informacionEnviar)
        if (tempoCXP?.length > 0) {
            setIdFactura(tempoCXP[0]?.Id)
            setDialogFactura(true)
        }
    }

    const hideDialog = () => {
        setDialogFactura(false)
        obtenerIngresosFechas()
    }

    const table = {
        Data: data,
        Columns: [

            {
                field: 'FechaIngreso',
                header: 'Fecha Ingreso',
                headerEn: 'Income Date',
                className: 'medium',
                Format: 'DateTime24',
                frozen: 'true',
                alignFrozen: 'left',
                filter: true
            },
            {
                field: 'StatusFinanzas',
                header: 'Estado',
                headerEn: 'Status',
                className: 'small',
                // Format: "Template",
                // body: (rowData) => EstadoTemplate(rowData),
                Format: 'Estado',
                body: (rowData) => ({
                    ID: rowData?.IdEstadoFinanzas,
                    Estado: rowData?.StatusFinanzas
                }),
                align: "center",
                alignFrozen: 'left'
            },

            {
                field: 'NumeroIngreso',
                header: 'Numero Ingreso',
                headerEn: 'Income Number',
                className: 'small',
                Format: "Center",
                Sumary: 'count',
                onCellDoubleClicked: ({ data }) => {
                    if (data?.IdIngreso) {
                        OpenDocumento(data)
                    }
                }


            },
            {
                field: 'IdDetalle',
                header: 'IdIngreso',
                headerEn: 'IdIngreso',
                className: 'Xsmall',
            },

            {
                field: 'PurchaseOrder',
                header: 'PO',
                headerEn: 'PO',
                className: 'small',
                Sumary: 'count',
                Format: "Center",


            },
            {
                field: 'Factura',
                header: 'Factura',
                headerEn: 'Invoice',
                className: 'medium',
                Format: 'Center'
            },

            {
                field: 'CodigoProducto',
                header: 'Codigo Producto',
                headerEn: 'Product Code',
                className: 'medium',
                Format: 'Center',
                onCellDoubleClicked: ({ data }) => {
                    if (data.IdComponent) {

                    }
                }

            },
            {
                field: 'NombreProducto',
                header: 'Producto',
                headerEn: 'Product',
                className: 'Xlarge',
                filter: true,
                align: "center",
                onCellDoubleClicked: ({ data }) => {
                    if (data.IdComponent) {

                    }
                }
            },
            {
                field: 'CustomerName',
                header: 'Proveedor',
                headerEn: 'Supplier',
                className: 'Xlarge',
            },
            {
                field: 'AgentName',
                header: 'Agente Compras',
                headerEn: 'Purchase Agent',
                className: 'medium',
            },
            {
                field: 'NombreCategoria',
                header: 'Nombre Categoria',
                headerEn: 'Category Name',
                className: 'large',
            },
            {
                field: 'NombreCategoriaFinanzas',
                header: 'Categoria Finanzas',
                headerEn: 'Finance Category',
                className: 'medium',

            },
            {
                field: 'NombreSubCategoriaFinanzas',
                header: 'SubCategoria Finanzas',
                headerEn: 'Finance SubCategory',
                className: 'small',
            },

            {
                field: 'UnitName',
                header: 'Unidad',
                headerEn: 'Unit',
                className: 'Xsmall',
                Format: 'Center'
            },
            {
                field: 'Moneda',
                header: 'Moneda',
                headerEn: 'Currency',
                className: 'Xsmall',
                Format: 'Center'

            },
            {
                field: 'Antiguedad',
                header: 'Antigüedad',
                headerEn: 'Aging',
                className: 'small',
                Format: 'Center'
            },
            {
                field: 'EstadoAntiguedad',
                header: 'Estado Antigüedad',
                headerEn: 'Aging Status',
                className: 'small',
                Format: 'Center'
            },
            {
                field: 'Ingreso',
                header: 'Ingreso',
                headerEn: 'Income',
                className: 'Xsmall',
                Format: "Decimal",
                Sumary: 'sum',
                frozen: 'true',
                alignFrozen: 'right'
            },
            {
                field: 'Precio',
                header: 'Precio',
                headerEn: 'Price',
                className: 'Xsmall',
                Format: "Decimal",
                Sumary: 'sum'
            },
            {
                field: 'SubTotal',
                header: 'SubTotal',
                className: 'small',
                Format: "Decimal",
                Sumary: 'sum'
            },
            {
                field: 'Descuento',
                header: 'Descuento',
                headerEn: 'Discount',
                className: 'Xsmall',
                Format: "Decimal",
                Sumary: 'sum'
            },
            {
                field: 'ISV',
                header: 'ISV',
                headerEn: 'ISV',
                className: 'Xsmall',
                Format: "Decimal",
                Sumary: 'sum'
            },
            {
                field: 'TipoIngreso',
                header: 'Tipo Ingreso',
                headerEn: 'Income Type',
                className: 'small',
                Format: 'Center'
            },
            {
                field: 'IsExento',
                header: 'IsExento',
                className: '',
                Format: 'Checkbox',
                frozen: true,
                width: 70,
                alignFrozen: 'right',
                onChange: (e, rowData) => { },
            },
            {
                field: 'PrecioUL',
                header: 'Precio L',
                headerEn: 'Price L',
                className: 'Xsmall',
                Format: "Decimal",
                hidden: userAuth?.IdRol === 1,
                frozen: true,
                alignFrozen: 'right'
            },
            {
                field: 'CostoL',
                header: 'Total L',
                headerEn: 'Cost L',
                className: 'Xsmall',
                Format: "Currency",
                Sumary: 'sum',
                hidden: userAuth?.IdRol === 1,
                frozen: true,
                alignFrozen: 'right',
            },
            {
                field: 'PrecioUD',
                header: 'Precio $',
                headerEn: 'Price $',
                className: 'Xsmall',
                Format: "Decimal",
                hidden: userAuth?.IdRol === 1,
                frozen: true,
                alignFrozen: 'right'
            },
            {
                field: 'CostoD',
                header: 'Total $',
                headerEn: 'Cost $',
                className: 'Xsmall',
                Format: "Currency",
                hidden: userAuth?.IdRol === 1,
                frozen: true,
                alignFrozen: 'right',
                Sumary: 'sum'
            },
            {
                field: 'TasaCambio',
                header: 'Tasa cambio',
                className: 'Xsmall',
                Format: "Decimal",
                Sumary: 'sum'
            },
            {
                field: 'PrecioL',
                header: 'Precio L',
                headerEn: 'Price L',
                className: 'Xsmall',
                Format: "Decimal",
                frozen: true,
                alignFrozen: 'right'
            },
            {
                field: 'MontoL',
                header: 'Monto L',
                headerEn: 'Amount L',
                className: 'Xsmall',
                Format: "Currency",
                Sumary: 'sum',
                frozen: true,
                alignFrozen: 'right',
            },
            {
                field: 'PrecioD',
                header: 'Precio $',
                headerEn: 'Price $',
                className: 'Xsmall',
                Format: "Decimal",
                frozen: true,
                alignFrozen: 'right'
            },
            {
                field: 'MontoD',
                header: 'Monto $',
                headerEn: 'Amount $',
                className: 'Xsmall',
                Format: "Currency",
                frozen: true,
                alignFrozen: 'right',
                Sumary: 'sum'
            },


        ]
    }


    // const getInfo = async () => {
    //     setLoading(true);

    //     const fechas = getDateProduction(dates);
    //     const a = await getIngresosBodegaMantenimientoFecha({ fecha1: fechas[0], fecha2: fechas[1] });
    //     console.log(a);
    //     setIngresos(a)


    //     setLoading(false);
    // }
    // useEffect(() => {
    //     getInfo()
    // }, [])

    return (
        <div>

            <Toast ref={toast} />
            <Loader loading={loading} querySelector={'#IngresosMantenientoDet'} />
            <Card
                titulo={<div className='d-flex' style={{ alignItems: 'center' }}>

                    <CalendarioOperativo
                        getInfo={getIngresosDetallesFechas}
                        data={data}
                        setData={setData}
                        Nombre='Ingresos Bodega'
                        dates={dates}
                        setDates={setDates}
                        type="MonthPartida"
                        loading={loading}
                        setLoading={setLoading}

                    />

                </div>}

                contenido={<div className='pt-4' style={{ height: '85vh' }} id='IngresosMantenientoDet'>

                    <AgGrid table={table} />

                </div>}
            />
            <ModalCuentasPorPagarCompras
                dialogCuentas={dialogFactura}
                hideDialog={hideDialog}
                IdFactura={IdFactura}

            />
        </div>)
}

export default IngresosMantenimiento;